export default __webpack_public_path__ + "static/media/fields.dda8e312.svg";